import React, { ReactElement, useEffect, useMemo } from 'react';
import { Form } from 'formik';
import { useDataCollection } from '../../../../../hooks';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import { DataCollectionValues } from '../../../../../types';
import FormControl from '../../../../components/Form/FormControl';
import StepHeader from '../../../../components/Layout/StepHeader';
import InfoCard from '../../../../components/Layout/InfoCard';
import { TextsStepMeasuredHeatLossPENB } from '../../../../../data/dictionary';

interface FormError {
    measuredHeatLoss?: string;
}

const stepValidation = (values: DataCollectionValues) => {
    const errors: FormError = {};

    if (!values.measuredHeatLoss || Number(values.measuredHeatLoss) < 0) {
        errors.measuredHeatLoss = 'Povinné pole';
    }

    return errors;
};

const StepMeasuredHeatLossPENB = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    const errors = useMemo(() => stepValidation(values), [values]);
    useEffect(() => {
        completeStep && completeStep(!Object.keys(errors).length);
    }, [errors]);

    return (
        <Form>
            <StepHeader title="Měrná ztráta prostupem tepla" subtitle="Vyplňte prosím hodnotu z průkazu Vaší budovy" />
            <InfoCard img="ztrata-prostupem.jpg" texts={TextsStepMeasuredHeatLossPENB} />
            <div className="otz-house-info otz-house-info-small">
                <div className="otz-house-info__item">
                    <div className="otz-house-info__inner">
                        <div className="otz-house-info__title-small">Měrná ztráta prostupem tepla</div>
                        <div className="otz-house-info__select">
                            <div className="form-container form-container--text">
                                <FormControl
                                    name="measuredHeatLoss"
                                    id="measuredHeatLoss"
                                    type="number"
                                    tag="input"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.measuredHeatLoss}
                                    error={errors.measuredHeatLoss}
                                />
                                <div className="wiz-form-text">W/K</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepMeasuredHeatLossPENB;
